import React, { useEffect, useState } from "react";
// import AnimatedNumbers from "react-animated-numbers";
// import { ToastContainer } from "react-toastify";
import FooterFooter from "../../components/footerfooter";
//IMPORT DYNAMIC STYLED COMPONENT
import { StyledHeader } from "../../Styles";
import { IoDiamondOutline } from "react-icons/io5";
import CountUp from "react-countup";
import "./styles/newMint.scss";
import { CONFIG } from "../../../config.js";
import { ABI, DashboardFunctions } from "./functions";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";
import ReactVisibilitySensor from "react-visibility-sensor";
import NewsLetterSection from "./component/shared/footer/newLetterSection";

//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO

const NewMint = () => {
  const {
    authenticate,
    isAuthenticated,
    user,
    Moralis,
    setUserData,
    userError,
    isWeb3Enabled,
    account,
    ...xyz
  } = useMoralis();
  const [mintAmount, setMintAmount] = useState({
    mintQuantity: 0,
  });

  const notifySuccess = (message) =>
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyInfo = (message) =>
    toast.info(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyError = (message) =>
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  async function handleSide(option) {
    const { label, value } = option;
    console.log("value=", value, "label=", label);
    console.log(label);
    await setMintAmount({
      ...mintAmount,
      mintQuantity: value,
    });
  }

  const { data, error, fetch, isFetching, isLoading } =
    useWeb3ExecuteFunction();
  async function mintNFT2(val) {
    await Moralis.enableWeb3();

    const etherValue = val * 0.01;
    let options = {
      chain: CONFIG.chainID,
      contractAddress: CONFIG.smart_contract_erc721,
      functionName: "mintMetaMooseMansion",
      abi: ABI.mintMetaMooseMansion,
      params: {
        _count: val,
      },
      msgValue: Moralis.Units.ETH(etherValue),
    };
    // await Moralis.enableWeb3();
    console.log("mintUser=>", user);
    try {
      const mintTransaction = await Moralis.executeFunction(options);
      console.log(
        "mintTransaction=>",
        mintTransaction,
        "mintTransactionhash",
        mintTransaction.hash
      );
      notifyInfo("Please wait for confirmation");
      await mintTransaction.wait();
      notifySuccess("Please reload after sometime to get the minted NFT");
    } catch (e) {
      console.log("mintError=>", e);
      notifyError("Oops some problem occured! Please try again later!");
    }
    if (
      typeof error?.code == "undefined" &&
      typeof error?.data != "undefined"
    ) {
      notifySuccess("Please Wait For Sometime Transaction is Successful");
    } else if (typeof error?.code != "undefined") {
      notifyError("There is some error Please Try Again Later");
    }
  }

  const customStyles = {
    option: (base, state) => ({
      ...base,
      background: "#fff",
      color: "#333",
      borderRadius: state.isFocused ? "0" : 0,
      "&:hover": {
        background: "#eee",
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
    control: (base, state) => ({
      ...base,
      padding: 2,
      height: 60,
    }),
  };

  return (
    <>
      <div className="greyscheme">
        <StyledHeader theme={theme} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <div className="greyscheme">
          <section className="hero_section_mint">
            <div className="section_mint_overly"></div>
            <div className="container">
              <div className="row">
                <div className="col-md-6 content_col">
                  <div className="hero_content">
                    <div
                      className="title"
                      data-aos="fade-up"
                      data-aos-delay="500"
                      data-aos-duration="5000"
                      data-aos-once="true"
                      data-aos-easing="ease-in-out"
                    >
                      <h2>Mint A Moose!</h2>
                      <span className="divider"></span>
                    </div>
                    <div className="desc">
                      Ready to join the herd and start your journey? Minting one
                      gets you access to the private discord. Minting 2 gets you
                      started on your path to a Free Mini Moose! Yup, Free! Just
                      stake them for 90 days to earn an adorable Mini Moose to
                      add to your collection!
                    </div>
                    <div className="button_text d-flex">
                      <button
                        className="mint"
                        onClick={() => mintNFT2(mintAmount.mintQuantity)}
                      >
                        Mint-A-Moose{" "}
                        <IoDiamondOutline style={{ color: "#fff" }} />
                      </button>
                      <Select
                        styles={customStyles}
                        onChange={handleSide}
                        // onChange={(option) => mintNFT2(option.valaue)}
                        options={[
                          { value: "1", label: "1" },
                          { value: "2", label: "2" },
                          { value: "3", label: "3" },
                          { value: "4", label: "4" },
                          { value: "5", label: "5" },
                          { value: "6", label: "6" },
                          { value: "7", label: "7" },
                          { value: "8", label: "8" },
                          { value: "9", label: "9" },
                          { value: "10", label: "10" },
                        ]}
                      />
                    </div>

                    <div className="counter_number">
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <CountUp end={5000} start={0} delay={1}>
                            {({ countUpRef, start }) => (
                              <ReactVisibilitySensor
                                partialVisibility
                                onChange={start}
                              >
                                <span ref={countUpRef} />
                              </ReactVisibilitySensor>
                            )}
                          </CountUp>
                        </span>
                        <div className="text">Moose</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <CountUp end={200} start={0} delay={1} suffix="+">
                            {({ countUpRef, start }) => (
                              <ReactVisibilitySensor
                                partialVisibility={false}
                                onChange={start}
                              >
                                <span ref={countUpRef} />
                              </ReactVisibilitySensor>
                            )}
                          </CountUp>
                        </span>
                        <div className="text">Traits</div>
                      </div>
                      <div
                        className="counter_wrapper"
                        data-aos="fade-up"
                        data-aos-delay="800"
                        data-aos-duration="5000"
                        data-aos-once="true"
                        data-aos-easing="ease-in-out"
                      >
                        <span className="count">
                          <CountUp end={15} start={0} delay={1}>
                            {({ countUpRef, start }) => (
                              <ReactVisibilitySensor
                                partialVisibility={false}
                                onChange={start}
                              >
                                <span ref={countUpRef} />
                              </ReactVisibilitySensor>
                            )}
                          </CountUp>
                        </span>
                        <div className="text">Ultra Rare NFTs</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className="hero_image"
                    data-aos="fade-up"
                    data-aos-delay="500"
                    data-aos-duration="5000"
                    data-aos-once="true"
                    data-aos-easing="ease-in-out"
                  >
                    <div className="image_bg">
                      <div className="img_wrapper">
                        <img
                          src="https://moosesocietynft.io/wp-content/uploads/elementor/thumbs/website-graphics2-pm0u2ukuay0ypbwhoxxh6w6p0ww87janzqbqpa26rs.png"
                          alt="img"
                          data-aos="fade-up"
                          data-aos-delay="1000"
                          data-aos-duration="5000"
                          data-aos-once="true"
                          data-aos-easing="ease-in-out"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <br />
          <br />
          <NewsLetterSection />
          <FooterFooter />
        </div>
      </div>
    </>
  );
};

export default NewMint;
